import React from "react";
import { Container } from "reactstrap";
import Content from "./Content";
import { APP_NAME_SHORT } from "common/constants";
import { useParams, useLocation } from "react-router-dom";
import BreadCrumb from "Components/Common/BreadCrumb";
import { usePageActivity } from "Components/Hooks/UsePageActivity";

const ViewPerson = () => {
  const location = useLocation();
  const { id: personId } = useParams();
  usePageActivity(location.pathname, "View Person", personId);

  document.title = `View Person | ${APP_NAME_SHORT}`;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Person Details"
            pageTitles={[
              {
                title: "Dashboard",
                link: "/",
              },
              { title: "Persons", link: "/persons" },
            ]}
            back
          />

          <Content personId={personId || ""} />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ViewPerson;
